import { ReactElement } from 'react';
import { Alert, Button } from '@mantine/core';
import { parseZone } from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { Route } from '../../utils/config';
import styles from './OrderConfirmation.module.scss';

export function AdjustOrderBanner(): ReactElement {
  const { menu } = useMenuWithCart();
  const navigate = useNavigate();

  const cartCloseDeadline = menu?.endAt
    ? parseZone(menu.endAt)
      .format('MMM D')
    : null;

  return (
    <Alert classNames={{ root: styles.adjust_order_banner }}>
      <div className={styles.adjust_order_banner_body}>
        <span className={styles.adjust_order_banner_text}>
          {`Want to adjust your order? Don’t worry - You can make changes until ${cartCloseDeadline}.`}
        </span>
        <Button
          onClick={() => {
            navigate(Route.HUB);
            window.scrollTo(0, 0);
          }}
          color="dark"
        >
          Adjust Order
        </Button>
      </div>
    </Alert>
  );
}
